export enum MethodManagerActions {
  OPEN_METHOD_DETAILS,
  CLOSE_MODAL,
  CLOSE_DIALOG,
  OPEN_MODAL,
  SELECT,
  SELECT_SCREEN,
}
